import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import Automation from "./sections/Automation";
import Rochester from "./sections/Rochester";
import DirectDetails from "./sections/DirectDetails";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <Automation />
      <Rochester />
      <DirectDetails />
      <Footer />
    </div>;
}